/* eslint-disable */
// /src/pages/FranchiseStorePage.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import PageTopBar from "../components/PageTopBar";
import { fetchActiveFranchiseProducts } from "../services/franchiseStorePublicService";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #D7E8FF 0%, #EAF3FF 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #F7FAFF;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0,0,0,.05);
`;

/* 카드 그리드 */
const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
`;

const Grid = styled.div`
  width:100%;
  display:grid;
  gap:14px;
  grid-template-columns: repeat(2, minmax(0,1fr));
  max-width: 760px;
  margin: 0 auto;

  align-items: start;
  align-content: start;
  grid-auto-rows: max-content;

  @media (max-width:560px){
    grid-template-columns: 1fr;
    gap:12px;
  }
`;

const Card = styled.button`
  text-align:left;
  border:1px solid #E5E7EB;
  border-radius:16px;
  background:#fff;
  overflow:hidden;
  cursor:pointer;
  display:flex;
  flex-direction:column;
  padding:0;
  box-shadow:0 1px 10px rgba(0,0,0,.04);

  .thumb{
    height:140px;
    background:#fff;
    display:flex;
    align-items:center;
    justify-content:center;
  }
  .thumb img{
    width:100%;
    height:100%;
    object-fit:contain;
    display:block;
  }

  .body{
    padding:12px;
    display:flex;
    flex-direction:column;
    gap:6px;
  }
  .title{
    font-weight:900;
    font-size:16px;
    color:#0f172a;
    line-height:1.25;
    max-height:2.6em;
    overflow:hidden;
  }
  .price{
    font-weight:800;
    color:#111;
  }
  .desc{
    color:#64748b;
    font-size:13px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
`;

const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

const EmptyBox = styled.div`
  margin-top: 24px;
  padding: 24px 14px;
  border-radius: 16px;
  border: 1px dashed #d1d5db;
  background: #ffffff;
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.7;
`;

const KRW = (n = 0) => (Number(n || 0)).toLocaleString("ko-KR") + "원";

export default function FranchiseStorePage() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const list = await fetchActiveFranchiseProducts();
        if (alive) setRows(list);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Wrap>
      <Sheet>
        <PageTopBar
          right={
            <>
              <PageTopBar.ActionButton onClick={() => nav("/franchise-store/cart")} aria-label="가맹점 장바구니 보기">
                장바구니
              </PageTopBar.ActionButton>
              <PageTopBar.ActionButton onClick={() => nav("/franchise/orders")} aria-label="가맹점 주문 내역 보기">
                주문 내역
              </PageTopBar.ActionButton>
            </>
          }
        />

        <Body>
          <div style={{ maxWidth: 760, width: "100%", margin: "0 auto" }}>
            <BrandHeader subtitle="가맹점 스토어" />
          </div>

          {loading ? (
            <div style={{ padding: 16 }}>불러오는 중…</div>
          ) : rows.length ? (
            <>
              <Grid>
                {rows.map((r) => (
                  <Card
                    key={r.id}
                    onClick={() => nav(`/franchise-store/${r.id}`)}
                  >
                    <div className="thumb">
                      {r.thumb ? <img src={r.thumb} alt="" /> : null}
                    </div>
                    <div className="body">
                      <div className="title">{r.title}</div>
                      <div className="price">{KRW(r.priceKRW)}</div>
                      {r.shortDesc ? (
                        <div className="desc">{r.shortDesc}</div>
                      ) : null}
                    </div>
                  </Card>
                ))}
              </Grid>
              <BottomPad />
            </>
          ) : (
            <EmptyBox>등록된 가맹점 상품이 없습니다.</EmptyBox>
          )}
        </Body>
      </Sheet>
    </Wrap>
  );
}
